<template>
  <div>
    <button class="tabulka__top__button" @click="updateBalanceTable()">
      Balance list
    </button>
    <Modal ref="modalRef" maxWidth="1200px">
      <div class="modal__budgetDiv">
        Balance List: <span>{{ teamName }}</span>
      </div>
      <div class="modal__budgetDiv">
        Budget: <span>{{ teamMoney }} €</span>
      </div>
      <div class="clearFix"></div>
      <div class="tabulka__body noPadding marginTop">
        <table>
          <thead>
            <td>
              <span>Round</span>
              <SortButton
                row="round"
                type="0"
                :currentSortDirection="currentSortDirection"
                :currentSortRow="currentSortRow"
                v-on:sortBy="sortRow"
              />
            </td>
            <td>
              <span>Transaction name</span>
              <SortButton
                row="transactionName"
                type="a"
                :currentSortDirection="currentSortDirection"
                :currentSortRow="currentSortRow"
                v-on:sortBy="sortRow"
              />
            </td>
            <td class="right">
              <SortButton
                row="earned"
                type="0"
                :currentSortDirection="currentSortDirection"
                :currentSortRow="currentSortRow"
                v-on:sortBy="sortRow"
                floatRight="yes"
              />
              <span>Earned</span>
            </td>
          </thead>
          <tr v-for="row in sortedData" :key="row.id">
            <td class="important">
              <span>{{ row.turn }}.</span>
            </td>
            <td>{{ displayName(row.type) }}</td>
            <td
              class="right"
              :class="{ red: row.budget < 0, green: row.budget > 0 }"
            >
              {{ row.budget | numbersThousands | inCurrency }}
            </td>
          </tr>
        </table>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/general/Modal.vue";
import ModalJs from "@/components/general/ModalJs.js";

import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js";
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
export default {
  name: "BalanceList",
  mixins: [ModalJs, sortingLogicMixin],
  components: {
    Modal,
    SortButton,
  },
  props: {
    teamId: Number,
    teamName: String,
    teamMoney: Number,
  },
  data() {
    return {
      currentSortRow: "turn",
    };
  },
  methods: {
    async updateBalanceTable() {
      await this.$store.dispatch("fetchTeamFinanceOwnerDetail", this.teamId);
      this.$refs.modalRef.open();
    },
    displayName(name) {
      let NamePre = name.toLowerCase().trim();
      let NameSpace = NamePre.replace("_", " ");
      let Name = NameSpace.charAt(0).toUpperCase() + NameSpace.slice(1);
      return Name;
    },
  },
  computed: {
    ...mapGetters({
      sourceData: "teamFinancialOverviewOwnerDetail",
    }),
  },
};
</script>